import api from "@/config/request";
export const uploadChunk = (formData) => {
  return api.post('/openApi/copyright/uploadByChunk', formData,{timeout: 120000})
    .then(res => res.data)
}